import React, { useEffect, useState } from "react";
import { getConsent, setConsent, OPEN_CONSENT_EVENT } from "../lib/analytics";

export default function CookieConsent() {
  const [open, setOpen] = useState(() => !getConsent());

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(OPEN_CONSENT_EVENT, show);
    return () => window.removeEventListener(OPEN_CONSENT_EVENT, show);
  }, []);

  if (!open) return null;

  const choose = (value) => {
    setConsent(value);
    setOpen(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-3xl rounded-2xl border border-moss-800 bg-moss-950/95 px-5 py-4 text-cream-50 shadow-2xl shadow-moss-950/30 backdrop-blur-md sm:inset-x-6 sm:bottom-6"
      data-testid="cookie-banner"
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm leading-relaxed text-cream-100/85" data-testid="cookie-banner-text">
          We&apos;d like to use analytics cookies to count page views and improve
          the site. Nothing is tracked unless you accept.{" "}
          <a
            href="/cookies"
            className="font-semibold text-sage-300 underline underline-offset-2 hover:text-sage-200"
            data-testid="cookie-banner-policy-link"
          >
            Cookie Policy
          </a>
        </p>
        <div className="flex flex-shrink-0 gap-2">
          <button
            type="button"
            onClick={() => choose("rejected")}
            className="h-10 rounded-full border border-cream-50/30 px-5 text-sm font-semibold text-cream-50 transition-colors hover:bg-cream-50/10"
            data-testid="cookie-reject-btn"
          >
            Reject
          </button>
          <button
            type="button"
            onClick={() => choose("accepted")}
            className="h-10 rounded-full bg-sage-500 px-5 text-sm font-bold text-moss-950 transition-colors hover:bg-sage-400"
            data-testid="cookie-accept-btn"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
